import {useCallback, useEffect, useState} from 'react';

import { getProfileChat } from '../../utils/api';

import Header from '../header/Header';
import Transcript from '../transcript/Transcript';

import './Details.css';

function Details({ handleConfetti, handleError, handleFeedback, handlePath, handleStartOver }) {
  const [messages, setMessages] = useState(null);

  const loadMessages = useCallback(async () => {
    try {
      setMessages(await getProfileChat());
    } catch (e) {
      handleError(e);
    }
  }, [handleError]);

  useEffect(() => {
    loadMessages();
  }, [loadMessages]);

  return (
    <>
      <Header activeElement="profile" handleFeedback={handleFeedback} handlePath={handlePath} handleStartOver={handleStartOver} />
      <div id="profile" className="clamp">
        <Transcript activity={false} handleConfetti={handleConfetti} handleError={handleError} handlePath={handlePath} isProfile={true} transcript={messages} />
      </div>
    </>
  );
}

export default Details;
